var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBathtubBath(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.25 13L15.75 15H0.25L2.75 13",
    stroke: "#464646",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.97063 5.34964C3.97063 5.34964 0.353133 5.24402 0.250008 5.25027C0.247332 7.1575 0.950631 8.99823 2.22438 10.4178C2.41188 10.629 2.88751 10.7509 3.17188 10.7509",
    stroke: "#464646",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.25 10.7499H13C13.1452 10.75 13.2889 10.7204 13.4222 10.663C13.5556 10.6057 13.6759 10.5216 13.7756 10.4162C14.6206 9.47072 15.221 8.33261 15.5244 7.10141C15.8277 5.87021 15.8247 4.58344 15.5156 3.35367C15.4883 3.24713 15.4379 3.1479 15.3679 3.06303C15.298 2.97815 15.2102 2.9097 15.1108 2.86253C15.0115 2.81535 14.9029 2.79061 14.793 2.79005C14.683 2.78949 14.5742 2.81313 14.4744 2.85929L10.5188 4.68304C10.1093 4.87244 9.68496 5.02776 9.25 5.14742",
    stroke: "#464646",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.25 10.75H3.17188",
    stroke: "#464646",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 10.75H15.75",
    stroke: "#464646",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.5 4V2C0.5 1.73478 0.605357 1.48043 0.792893 1.29289C0.98043 1.10536 1.23478 1 1.5 1V1C1.76522 1 2.01957 1.10536 2.20711 1.29289C2.39464 1.48043 2.5 1.73478 2.5 2V2.25",
    stroke: "#464646",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.75062 9V10.8787C7.75111 11.0759 7.71272 11.2712 7.63765 11.4536C7.56258 11.6359 7.4523 11.8016 7.31312 11.9412L7.25062 12.0037H6.11625C5.87909 12.0039 5.64832 11.9269 5.45875 11.7844L5.44625 11.7756C5.11625 11.5256 4.665 11.48 4.3125 11.6912C4 11.8787 3.5 12.0037 2.75 11.7537C3.48687 10.8331 3.68062 7.60562 3.73187 5.97C3.73968 5.71002 3.84847 5.4633 4.03517 5.28221C4.22186 5.10111 4.47178 4.99988 4.73187 5H5.79437C5.92875 4.99943 6.06234 5.02054 6.19 5.0625H6.195C6.2565 5.08322 6.3191 5.10053 6.3825 5.11438C6.82 5.215 7.2775 5.125 7.67437 4.9175L8.00062 4.75L7.95562 4.88438C7.81988 5.29232 7.75066 5.71944 7.75062 6.14937V9Z",
    stroke: "#464646",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.24953 10.25C5.24953 10.25 4.98828 11.3062 4.73828 11.5562",
    stroke: "#464646",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.06812 5.03027C5.81812 5.28027 5.75 5.75027 5.75 5.75027",
    stroke: "#464646",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBathtubBath);
export default __webpack_public_path__ + "static/media/bathtub-bath.717fe2a2.svg";
export { ForwardRef as ReactComponent };